import {OnInit} from "@angular/core/core";
import {Injectable, Inject} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable, of} from "rxjs";
import { map } from 'rxjs/operators';
import { User } from '../../model/dto/user'
import { AppConfig } from '../../core/configs/app-config';
import { Router } from '@angular/router';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
@Injectable()

export class UserService implements OnInit {
    private config: any = {};
    public currentUser: User;
    public authenticated: boolean = false;
    public parameter: any = 0;

    constructor(private _fuseNavigationService: FuseNavigationService, private router: Router,@Inject(HttpClient)private http?: HttpClient) {
        this.config = {
            "SERVERPROTOCOL": AppConfig.ApiProtocol,
            "SERVERURL": AppConfig.ApiLoginHost,
            "SERVERPORT": AppConfig.ApiPort,
            "APPLICATIONID": AppConfig.ApiApplicationId,
            "METHOD": AppConfig.ApiMethod,
            "LOGINURL": AppConfig.ApiLoginUrl,
            "STACKURL": AppConfig.ApiUrl
          }
    }

    ngOnInit(): void {
        // thats empty
    }

    public isAuthenticated(): Observable<boolean> {
        
 /*        console.log(this.currentUser.Token);
        let headers: HttpHeaders = new HttpHeaders({
        "Authorization": "Bearer "+ localStorage.getItem('userToken') });
    
        let loginAction: any;
        let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/auth/ping/"
         loginAction = await this.http.get(conString, {headers: headers}).pipe(map((results:any) => {
             console.log("dsadsa");
            this.authenticated = true;
          } , (error) => {
                console.log("loginAction error", error);
                this.authenticated = false;
            }));
            console.log("test") */

            if (localStorage.getItem('userToken') != null) {
                console.log("not empty");
                this.authenticated = true;
            }
        return of(this.authenticated);
    }

    public init(config: any): void {
        this.config = config;
    }

    public getAuthenticationtoken(): string {
        if (this.currentUser) {
            return this.currentUser.Token;
        }
        return "";
    }

    public setParameter(parameter : any): any {
        console.log(parameter);
        this.parameter = parameter;
    }

    public getCurrentUser(): User {   
        if (this.currentUser == null) {
            this.currentUser = new User(parseInt(localStorage.getItem('employeeID')), localStorage.getItem('cplName'), localStorage.getItem('firstName'),localStorage.getItem('lastName'),localStorage.getItem('email'),parseInt(localStorage.getItem('departmentID')),localStorage.getItem('department'),localStorage.getItem('token'),parseInt(localStorage.getItem('bedrijfID')));
        }
        return this.currentUser;
    }
 
    public logout(): void {
        console.log("loggin out");
        this.currentUser = null;
        this.authenticated = false;
        this.router.navigate(['/login']);  // {4}
    }

    public async login(username: string, password: string) {

        let headers: HttpHeaders = new HttpHeaders({ 'Access-Control-Allow-Origin': '*', "Content-Type": "application/x-www-urlencoded",
        "No-Auth": "True", });

       
        let promise = await new Promise<void>(async (resolve, reject) => {
            let conString: string = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + this.config.LOGINURL;
            var data = "username=" + username + "&password=" + password + "&grant_type=password";
            console.log(conString);
           await this.http.post(conString, data, {headers: headers}).toPromise().then(
                json => {
                    console.log(json);
                    let userObject: any = json;
                    this.currentUser = new User(userObject.EmployeeID, userObject.CplName, userObject.FirstName, userObject.LastName, userObject.Email, userObject.DepartmentID, userObject.Department, userObject.access_token, userObject.BedrijfID);
       
                    localStorage.setItem('userToken',userObject.access_token);
                    localStorage.setItem('userRoles',userObject.roles);
                    localStorage.setItem('employeeID', userObject.EmployeeID);
                    localStorage.setItem('bedrijfID', userObject.BedrijfID);
                    localStorage.setItem('cplName', userObject.CplName);
                    localStorage.setItem('firstName', userObject.FirstName);
                    localStorage.setItem('lastName', userObject.LastName);
                    localStorage.setItem('email', userObject.Email);
                    localStorage.setItem('departmentID', userObject.DepartmentID);
                    localStorage.setItem('department', userObject.Department);
                    localStorage.setItem('token', userObject.access_token);
                    console.log(localStorage.getItem('cplName'));   
                    this.authenticated = true;
                    this.setNavigationRoles();
                    resolve();
                }, msg => { // Error
                    reject(false);
                  }
            );
        });
 
        return promise;
    }

    roleMatch(allowedRoles): boolean {
        var isMatch = false;
        var userRoles: string[] = JSON.parse(localStorage.getItem('userRoles'));
        allowedRoles.forEach(element => {
          if (userRoles.indexOf(element) > -1) {
            isMatch = true;
            return false;
          }
        });
        return isMatch;
      }

      setNavigationRoles(){

        this._fuseNavigationService.updateNavigationItem('medewerkers', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('afdelingen', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('planningoverzicht', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('planningsimpel', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('planningsimpelKlant', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('buitendienst', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('home', {
            hidden: true
        });
        this._fuseNavigationService.updateNavigationItem('homeklant', {
            hidden: true
        });

        var userRoles: string[] = JSON.parse(localStorage.getItem('userRoles'));
        userRoles.forEach(element => {
            if (element == "mws") {
                this._fuseNavigationService.updateNavigationItem('medewerkers', {
                    hidden: false
                });
                this._fuseNavigationService.updateNavigationItem('afdelingen', {
                    hidden: false
                });
                this._fuseNavigationService.updateNavigationItem('buitendienst', {
                    hidden: false
                });
                this._fuseNavigationService.updateNavigationItem('planningoverzicht', {
                    hidden: false
                });
                this._fuseNavigationService.updateNavigationItem('planningsimpel', {
                    hidden: false
                });
                this._fuseNavigationService.updateNavigationItem('home', {
                    hidden: false
                });

            }

            if (element == "planner") {
                this._fuseNavigationService.updateNavigationItem('planningoverzicht', {
                    hidden: false
                });
            }

            if (element == "Klant") {
                this._fuseNavigationService.updateNavigationItem('planningsimpelKlant', {
                    hidden: false
                });
                this._fuseNavigationService.updateNavigationItem('homeklant', {
                    hidden: false
                });
            }
          
        });
        
      }

}